import style from '../../Styles/index.module.scss'
import PromptBtn from '../../../../buttons/PromptBtn/PromptBtn'
import AppButton from '../../../../buttons/AppButton/AppButton'
import { ImportExportDataDropdown } from '../../../../overlays/DataImportExportCsv/ImportExportDataDropdown'
import React, { ReactNode } from 'react'
import { showModal } from '../../../../../store/actions/modalActions'
import { ModalTypes } from '../../../../../types/modals'
import { useAppDispatch } from '../../../../../hooks/useAppDispatch'
import { exportDataToCsv } from '../../../../../utils/exportDataToCsv'
import fileDownload from 'js-file-download'
import { CsvDataImporterArgs } from '../../../../modals/CsvModal/CsvModal'
import { getTableColumnValidators } from '../../utils/getTableColumnValidators'
import { validateCsvDataAndAddElementId } from '../../utils/validateCsvDataAndAddElementId'
import { TableAdvanced } from '../TableAdvanced/TableAdvanced'
import { DescriptionBtnWithPopup } from '../../../../buttons/PromptBtn/DescriptionBtnWithPopup'
import { showRightBar } from '../../../../../store/actions/rightBarActions'
import { ModeEditBtn } from '../../../../buttons/ModeEditBtn/ModeEditBtn'
import { getLabel } from '../../../../../utils/getLabel'
import { configsActions } from '../../../../../store/slices/configsSlice'
import { checkUnsavedChanges } from '../../../../../store/actions/configurationActions'
import { modifyRuleCardConfig } from '../../../../../store/actions/ruleCardActions'

interface Props {
    children: ReactNode
    schema: any
    config: any[]
    path: string[]
    name: string
    toggle: (e: any) => void
    componentSchema: any
    description: string | undefined
    isParentDisabled?: boolean
    inCard?: boolean
    isRuleActive?: boolean
    onDeleteAll: Function
    isRuleCard?: boolean
}

export const BlockArrayTableHeadControls = ({
    children,
    schema,
    config,
    path,
    name,
    isParentDisabled,
    inCard,
    isRuleActive,
    toggle,
    componentSchema,
    description,
    onDeleteAll,
    isRuleCard,
}: Props) => {
    const dispatch = useAppDispatch()
    const { is_required: isRequired } = schema

    const styleHeader = [
        style.header,
        'rounded-top',
        inCard && !isRuleActive ? 'rule-inactive' : 'app-bg-navi-blue',
    ]
    const label = getLabel(name, schema.name)

    const handleDeleteAll = () => {
        dispatch(
            showModal(ModalTypes.MAIN_MODAL, {
                body: 'Delete all data in the table ?',
                onSubmit: onDeleteAll,
            })
        )
    }

    const handleExportToCsv = () => {
        const headerKeys = Object.keys(componentSchema)
        const csvFileBlob = exportDataToCsv(headerKeys, config)
        const fileName = path.join('-') + '.csv'
        fileDownload(csvFileBlob, fileName)
    }

    const handleImportSubmit = (data: any[]) => {
        if (isRuleCard) {
            dispatch(modifyRuleCardConfig({ path, data}))
        } else {
            dispatch(configsActions.importCsvDataToBlockArrayTable({ path, data}))
            dispatch(checkUnsavedChanges(path[0]))
        }
    }

    const handleImportFromCsv = () => {
        const importHandler = (args: CsvDataImporterArgs) => {
            const { dataFromCsv, setData, setError, setErrPosition } = args
            const columnsValidators = getTableColumnValidators(componentSchema)
            const isValidTableData = validateCsvDataAndAddElementId({
                componentSchema,
                columnsValidators,
                dataFromCsv,
                setError,
                setErrPosition,
            })
            isValidTableData && setData(dataFromCsv)
        }

        dispatch(
            showModal(ModalTypes.CSV_MODAL, {
                path,
                objectSchema: componentSchema,
                onImportFromCsv: importHandler,
                onImportSubmit: handleImportSubmit
            })
        )
    }

    const openAdvancedSettings = () => {
        dispatch(
            showRightBar({
                rightBarItem: (
                    <TableAdvanced
                        config={config}
                        schema={schema}
                        label={label}
                        path={path}
                        itemEditIndex={undefined}
                        isRuleCard={isRuleCard}
                    />
                ),
                disableHide: true,
            })
        )
    }

    return (
        <div className={styleHeader.join(' ')}>
            <div
                className="w-100"
                onClick={toggle}
            >
                <h4
                    className={`${style.title} ${!schema.name && style.capitalized}`}
                >
                    {label}
                </h4>
            </div>
            {isRequired && !config.length && !isParentDisabled && (
                <PromptBtn
                    className="me-2"
                    type="validation"
                    prompt="At least 1 item required"
                />
            )}
            <ModeEditBtn
                onClick={openAdvancedSettings}
                className="m-1 rounded"
            />
            <AppButton
                variant="delete"
                className="p-1 m-1 text-light"
                onClick={handleDeleteAll}
                disabled={!config?.length}
                tooltip="tooltips.deleteAllData"
            />
            <ImportExportDataDropdown
                importFromCsv={handleImportFromCsv}
                exportToCsv={handleExportToCsv}
            />
            {description && (
                <DescriptionBtnWithPopup
                    type="small"
                    header={label}
                    description={description}
                    className=" mx-1 text-white"
                />
            )}
            {children}
        </div>
    )
}
